class Share {
  constructor() {
    this.settings = {
      shareLink: '.share__link',
    };
  }

  init() {
    const shareLink = $(this.settings.shareLink);
    const $this = this;
    shareLink.on({
      click(e) {
        const href = $(this).attr('href');
        if (href.indexOf('mailto') === -1) {
          e.preventDefault();
          $this.constructor.openWindow(href);
        }
      },
    });
  }

  static openWindow(link) {
    const options = 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400px,width=600px';
    window.open(link, '', options);
  }
}

export default Share;
